import { Icon } from '@/design-system/icons/Icon';

type Props = { root?: string; here: string };

export const Crumbs = ({ root = 'CanaBiz', here }: Props) => (
  <nav className="crumbs" aria-label="Breadcrumbs">
    <span className="root">{root}</span>
    <Icon name="chevron" size={16} className="ic sep" />
    <span className="here">{here}</span>
  </nav>
);
